import { BBModel } from '../../bb_model';
import { BaseModel } from '../base';
import { BBService } from '../../bb_service';

class BookableItemModel extends BaseModel {

    constructor(data) {
        super(...arguments);
        this.name = '-Waiting-';

        let resolveFn;
        this.ready = new Promise((resolve) => {
            resolveFn = resolve;
        });

        this.ready.resolve = resolveFn;
        this.promise = this._data.$get('item');
        this.promise.then((val) => {
                let m, n;
                if (val.type === 'person') {
                    this.item = new BBModel.Person(val);
                    if (this.item) {
                        for (n in this.item._data) {
                            m = this.item._data[n];
                            if (this.item._data.hasOwnProperty(n) && (typeof m !== 'function')) {
                                this[n] = m;
                            }
                        }
                        return this.ready.resolve();
                    } else {
                        return this.ready.resolve();
                    }
                } else if (val.type === 'resource') {
                    this.item = new BBModel.Resource(val);
                    if (this.item) {
                        for (n in this.item._data) {
                            m = this.item._data[n];
                            if (this.item._data.hasOwnProperty(n) && (typeof m !== 'function')) {
                                this[n] = m;
                            }
                        }
                        return this.ready.resolve();
                    } else {
                        return this.ready.resolve();
                    }
                } else if (val.type === 'service') {
                    this.item = new BBModel.Service(val);
                    if (this.item) {
                        for (n in this.item._data) {
                            m = this.item._data[n];
                            if (this.item._data.hasOwnProperty(n) && (typeof m !== 'function')) {
                                this[n] = m;
                            }
                        }
                        return this.ready.resolve();
                    } else {
                        return this.ready.resolve();
                    }
                }
            }
        );
    }

    static $query(params) {
        return BBService.bookableItem.query(params);
    }
}

export {
    BookableItemModel
};
